<template>
  <div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="vsPrescriptionModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Prescription Information</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="oncloseclick"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="prescription-modal">
              <div class="prescription-languages">
                <h4>Prescription Languages</h4>
                <div class="languages-block">
                  <label class="container customcheck mart-10">
                    <span active="">Telugu (తెలుగు)</span>
                    <input type="checkbox" id="Telugu" checked disabled />
                    <span class="checkmark"></span>
                  </label>
                  <label class="container customcheck mart-10">
                    <span active="">English (English)</span>
                    <input
                      type="checkbox"
                      id="English"
                      :checked="selectedLanguage === 'en'"
                      @change="selectLanguage('en')"
                    />
                    <span class="checkmark"></span>
                  </label>
                  <label class="container customcheck mart-10">
                    <span active="">Hindi (हिंदी)</span>
                    <input
                      type="checkbox"
                      id="Hindi"
                      value="hi"
                      :checked="selectedLanguage === 'hi'"
                      @change="selectLanguage('hi')"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="prescription-tab">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="medicines-tab"
                      data-toggle="tab"
                      data-target="#medicines"
                      type="button"
                      role="tab"
                      aria-controls="medicines"
                      aria-selected="true"
                    >
                      <i class="fa fa-stethoscope"></i> Medicines
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="lifestyle-tab"
                      data-toggle="tab"
                      data-target="#lifestyle"
                      type="button"
                      role="tab"
                      aria-controls="lifestyle"
                      aria-selected="false"
                    >
                      <i class="fa fa-heart-o"></i> Lifestyle Suggestions
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="medicines"
                    role="tabpanel"
                    aria-labelledby="medicines-tab"
                  >
                    <div class="content-sec">
                      <div class="search-suggestions">
                        <label>Medicine Prescription</label>

                        <div class="container-comm">
                          <div class="v-autocomplete favsims-search input">
                            <div class="v-autocomplete-input-group">
                              <input
                                v-model="searchMedicines"
                                type="search"
                                maxlength="100"
                                class="v-autocomplete-input"
                                placeholder="Search medicine"
                              />
                            </div>
                          </div>
                          <!-- <label for="Search Suggestions" class="">
                                    <b>Search medicine</b>
                                </label> -->
                          <span class="addpre-search"></span>
                        </div>
                      </div>

                      <!-- <div class="checkbox-block">
                                <label class="container customcheck mart-10 stock-available stage-01" data-toggle="tooltip" data-placement="top" title="ABHRAKAHARITAKI(ABRH)">
                                    <span active="">ABHRAKAHARITAKI(ABRH)</span>
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                    <em class="stock-count">102</em>
                                </label>
                                <label class="container customcheck mart-10 stock-available stage-02" data-toggle="tooltip" data-placement="top" title="ABHRAKAHARITAKI(ABRH)">
                                    <span active="">ABHRAKAHARITAKI(ABRH)</span>
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                    <em class="stock-count">54</em>
                                </label>
                                <label class="container customcheck mart-10 stock-available stage-03" data-toggle="tooltip" data-placement="top" title="ABHRAKAHARITAKI(ABRH)">
                                    <span active="">ABHRAKAHARITAKI(ABRH)</span>
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                    <em class="stock-count">8</em>
                                </label>
                            </div> -->
                      <div class="checkbox-block">
                        <label
                          v-for="item in medicinesList"
                          :key="item.itemId"
                          :class="[
                            'container customcheck mart-10 stock-available',
                            item.currentStock > 0 ? 'stage-01' : 'stage-03',
                          ]"
                          data-toggle="tooltip"
                          data-placement="top"
                          :title="item.itemNameInEnglishOrFallback"
                        >
                          <span>{{ item.itemNameInEnglishOrFallback }}</span>
                          <input
                            type="checkbox"
                            :checked="isChecked(item.itemId)"
                            @change="toggleSelection(item.itemId)"
                          />
                          <span class="checkmark"></span>
                          <em class="stock-count">{{ item.currentStock }}</em>
                        </label>
                      </div>

                      <div class="legend-list">
                        <ul>
                          <li class="stock-legend legend-stage-01">
                            <span></span>Available
                          </li>
                          <li hidden class="stock-legend legend-stage-02">
                            <span></span>Partially available
                          </li>
                          <li class="stock-legend legend-stage-03">
                            <span></span>Out of stock
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="lifestyle"
                    role="tabpanel"
                    aria-labelledby="lifestyle-tab"
                  >
                    <div class="content-sec">
                      <div class="search-suggestions">
                        <label>Lifystyle Suggestions</label>

                        <div class="container-comm">
                          <div class="v-autocomplete favsims-search input">
                            <div class="v-autocomplete-input-group">
                              <input
                                v-model="searchLifestyle"
                                type="search"
                                maxlength="100"
                                class="v-autocomplete-input"
                                placeholder="Search suggestions"
                              />
                            </div>
                          </div>

                          <span class="addpre-search"></span>
                        </div>
                      </div>

                      <div class="checkbox-block">
                        <label
                          class="container customcheck mart-10"
                          v-for="item in lifestyleList"
                          :key="item.itemId"
                          :title="item.itemNameInEnglishOrFallback"
                          data-toggle="tooltip"
                          data-placement="top"
                        >
                          <span>{{ item.itemNameInEnglishOrFallback }}</span>
                          <input
                            type="checkbox"
                            :checked="isChecked(item.itemId)"
                            @change="toggleSelection(item.itemId)"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-right" style="margin-top: 20px">
                <button
                  class="primary-btn ripple"
                  data-toggle="modal"
                  data-target="#prescriptionPreview"
                >
                  Preview & Arrange
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Prescription Preview Drag to Recorder Modal-->

    <div
      class="modal fade"
      id="prescriptionPreview"
      tabindex="-1"
      aria-labelledby="prescriptionPreviewLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Prescription Preview Drag to Reorder</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="preview-drag-modal">
              <div class="preview-drag-block">
                <draggable
                  v-if="selectedItemsData.length"
                  tag="ul"
                  :list="selectedItemsData"
                  class="list-group"
                  handle=".handle"
                  item-key="itemId"
                  @update="onDragEnd"
                >
                  <li
                    v-for="item in selectedItemsData"
                    :key="item.itemId"
                    class="drag-main-block"
                  >
                    <div class="drag-block">
                      <div class="top">
                        <div>
                          <i
                            v-if="item.groupType == 'Medicines'"
                            class="fa fa-stethoscope"
                            aria-hidden="true"
                          ></i>
                          <i v-else class="fa fa-heart-o"></i>
                        </div>
                        <div class="main-content">
                          <h4>
                            {{ getItemName(item, "te") }}
                            <span v-if="selectedLanguage != 'te'">
                              ({{ getItemName(item, selectedLanguage) }})
                            </span>
                          </h4>

                          <!-- Telugu description -->
                          <div>
                            <div
                              v-if="
                                editingItemId === item.itemId &&
                                editingLang === 'te'
                              "
                              class="edit-hold"
                            >
                              <textarea
                                class="form-control"
                                v-model="editableDesc"
                                rows="3"
                              ></textarea>
                              <div class="edit-buttons">
                                <button
                                  @click="saveDescription(item)"
                                  class="primary-btn ripple"
                                >
                                  Save
                                </button>
                                <button
                                  @click="cancelEdit"
                                  class="secondary-btn ripple"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                            <div class="main-content-sub" v-else>
                              <p class="prescription-text">{{ getLanguageDesc(item, "te") }}</p>
                              <div class="edit-section bottom">
                                <a
                                  class="edit-icon"
                                  href="javascript:void(0);"
                                  @click="editItem(item, 'te')"
                                >
                                  <i class="fa fa-pencil"></i>
                                </a>
                              </div>
                            </div>
                          </div>

                          <!-- Selected language description -->
                          <div v-if="selectedLanguage != 'te'">
                            <div
                              v-if="
                                editingItemId === item.itemId &&
                                editingLang === selectedLanguage
                              "
                              class="edit-hold"
                            >
                              <textarea
                                class="form-control"
                                v-model="editableDesc"
                                rows="3"
                              ></textarea>
                              <div class="edit-buttons">
                                <button
                                  @click="saveDescription(item)"
                                  class="primary-btn ripple"
                                >
                                  Save
                                </button>
                                <button
                                  @click="cancelEdit"
                                  class="secondary-btn ripple"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                            <div class="main-content-sub" v-else>
                              <p class="prescription-text">
                                {{ getLanguageDesc(item, selectedLanguage) }}
                              </p>
                              <div class="edit-section bottom">
                                <a
                                  class="edit-icon"
                                  href="javascript:void(0);"
                                  @click="editItem(item, selectedLanguage)"
                                >
                                  <i class="fa fa-pencil"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="edit-section">
                          <a
                            class="del-icon"
                            href="javascript:void(0);"
                            @click="removeItem(item.itemId)"
                          >
                            <i class="fa fa-trash"></i>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div class="drag-icon handle">
                      <i class="fa fa-ellipsis-v"></i>
                      <i class="fa fa-ellipsis-v"></i>
                    </div>
                  </li>
                </draggable>
              </div>

              <div class="drag-legend">
                <p>This can be drag and drop to arrange</p>
                <span>
                  <i class="fa fa-ellipsis-v"></i>
                  <i class="fa fa-ellipsis-v"></i>
                </span>
              </div>

              <div class="text-right">
                <button data-dismiss="modal" class="secondary-btn ripple">
                  Continue Editing
                </button>
                <button class="primary-btn ripple" @click="SavePrescription(false)">
                  Save
                </button>
                <button
                  class="primary-btn ripple"
                  @click="SavePrescription(true)"
                >
                  Print Prescription
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="print-section-prescription"
      ref="printSectionPrescription"
      style="position: absolute; top: -9999px; left: -9999px"
    >
      <PrescriptionPrint
        :patient="patientInfo"
        :selectedItemsData="selectedItemsData"
        :doctorName="doctorName"
        :time="prescriptioncreatedtime"
        :selectedLanguage="selectedLanguage"
        :created_by="created_by_unique_id"
        :logoUrl="logoPath"
      />
    </div>
     <transition name="fade">
        <Messages
          v-if="isdisplaymsg"
          v-bind:datamessage="sucessmsgtext"
           :iserror="iserrormsg"
          v-on:closemsg="closeMessage"
          v-bind:isVisible="isdisplaymsg"
        ></Messages>
      </transition>
  </div>
</template>

<script>
import Axios from "axios";
import Auth from "@/common/mixins";
import rest_service from "@/api/rest_service";
import draggable from "vuedraggable";
import PrescriptionPrint from "@/components/FromTemplates/Prescription-medicine-suggestion.vue";
import logo from "@/assets/Nandagokulam-logo.jpg";
import Messages from "@/components/MessagePopup/Messages";
import InvoiceReceiptApi from '../../api/InvoiceReceipt.js'

export default {
  components: {
    draggable,
    PrescriptionPrint,
    Messages
  },
  props: {
    patientInfo: {
      type: Object,
      required: true,
    },
    isGlobal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    //for msg
    isdisplaymsg: false,
      iserrormsg: false,
      sucessmsgtext:"",

      isLoading: false,
      searchMedicines: "",
      searchLifestyle: "",
      listOfItems: [],
      preselectedIds: [],
      selectedItems: [],
      showauthenticationcheck: false,
      loggeedin_user: null,
      loggedin_user_id: null,
      role_unique_id: "",
      loggedin_user_unique_id: "",
      authenticationToken: "",
      tenantId: "",
      provider_id: "",
      selectedLanguage: "te",
      optionLanguageCode: "",
      //for dragable
      selectedItemsData: [],
      prescriptioncreatedtime: "",
      logoPath: logo,
      //for edit desc
      editingItemId: null,
      editingLang: null,
      editableDesc: "",
      IsPrintable: false,
      created_by_unique_id: "",
      isGetListFinished: false,
      isGetPreviousPrescriptionFinished: false,
      mergeDone: false,
      doctorName: "",
      isNewPrescription: false,
      getlocationdata:{}
    };
  },
  created() {
    this.showauthenticationcheck = false;
    if (JSON.parse(localStorage.loggedInUserInfo)) {
      this.tenantId = JSON.parse(localStorage.loggedInUserInfo).tenant_id;
      this.provider_id = JSON.parse(localStorage.loggedInUserInfo).unique_id;
      var loggeedin_userinfo = "";
      if (window.localStorage.getItem("accesstoken")) {
        this.authenticationToken = window.localStorage.getItem("accesstoken");
      }
      if (window.localStorage.getItem("loggedInUserInfo")) {
        loggeedin_userinfo = JSON.parse(
          window.localStorage.getItem("loggedInUserInfo")
        );
        this.loggeedin_user = loggeedin_userinfo;
      }
      if (loggeedin_userinfo && loggeedin_userinfo.role) {
        this.role_unique_id = loggeedin_userinfo.role.unique_id;
        this.loggedin_user_unique_id = loggeedin_userinfo.unique_id;
      }
      if (
        !this.loggeedin_user.is_service_provider &&
        this.loggeedin_user.unique_id
      ) {
        this.loggedin_user_id = this.loggeedin_user.unique_id;
      } else {
        this.loggedin_user_id = null;
      }
    } else {
      this.showauthenticationcheck = true;
    }
  },
  async mounted() {
    await this.getMedicineSuggestionList();
    await this.getPreviousPrescription();
    if(this.patientInfo.encounter_id) {
        var encounterParts = this.patientInfo.encounter_id.split("_");
        if(encounterParts && encounterParts.length > 1) {
          this.Getlocationdatabyappintmentid(encounterParts[1]);
        }
      }
  },

  methods: {
    Getlocationdatabyappintmentid(appointmentid){
            if(Auth.checkAuthentication()){
                
                var self = this;
                InvoiceReceiptApi.getappointment(appointmentid)
                .then(appointmentdetails => {
                    if (appointmentdetails.data) {
                        self.getlocationdata=appointmentdetails.data.result.facility;
                    }
                }).catch(error => console.log(error))
            }else{
                
                this.GotoAuthsignout();
            }
        },
     closeMessage() {
      this.isdisplaymsg = false;
      this.iserrormsg = false;
    },
    async refreshData(newInfo, isNewPrescription) {
      this.isNewPrescription = isNewPrescription;
      this.selectedItems = [];
      this.selectedItemsData = [];
      this.mergeDone = false;
      this.isGetPreviousPrescriptionFinished = false;
      this.isGetListFinished = false;
      this.IsPrintable = false;

      this.patientInfo = newInfo;

      await this.getMedicineSuggestionList();

      await this.getPreviousPrescription();
    },

    GetDoctorName() {
      // Parse staff list safely
      const staffList = JSON.parse(
        window.localStorage.getItem("AppStaffList") || "[]"
      );

      // Find doctor by created_by
      const selectedId =
        this.created_by_unique_id && this.created_by_unique_id.trim() !== ""
          ? this.created_by_unique_id
          : this.loggedin_user_unique_id;

      const doctor = staffList.find(function (staff) {
        return staff.unique_id === selectedId;
      });

      if (!doctor) return "";

      // Format name
      const title = doctor.title ? doctor.title.trim() : "";
      const firstName = doctor.first_name ? doctor.first_name.trim() : "";
      const lastName = doctor.last_name ? doctor.last_name.trim() : "";

      this.doctorName = `${title} ${firstName} ${lastName}`.trim();
    },
    mergeSelectedItems() {
      
      // Only merge once both APIs are finished and IsPrintable is false
      if (
        this.isGetListFinished &&
        this.isGetPreviousPrescriptionFinished &&
        this.IsPrintable === false &&
        !this.mergeDone &&
        this.preselectedIds.length
      ) {
        this.selectedItems = Array.from(
          new Set([...this.selectedItems, ...this.preselectedIds])
        );
        this.mergeDone = true; // prevent duplicate merging
      }
    },
    // getLanguageDesc(item, lang) {
    //   const langObj = item.languages.find((l) => l.languageCode === lang);
    //   return langObj.description || "";
    // },
    getLanguageDesc(item, lang) {
      if (!item || !item.languages || !item.languages.length) {
        return "";
      }

      const langObj = item.languages.find(function (l) {
        return l.languageCode === lang;
      });

      if (langObj && langObj.description) {
        return langObj.description;
      }

      return "";
    },

    editItem(item, lang) {
      this.editingItemId = item.itemId;
      this.editingLang = lang;
      this.editableDesc = this.getLanguageDesc(item, lang);
    },
    saveDescription(item) {
      const index = this.selectedItemsData.findIndex(
        (i) => i.itemId === item.itemId
      );
      if (index !== -1 && this.editingLang) {
        const langObj = this.selectedItemsData[index].languages.find(
          (l) => l.languageCode === this.editingLang
        );
        if (langObj) {
          langObj.description = this.editableDesc;
        } else {
          // If the language doesn't exist yet, add it
          this.selectedItemsData[index].languages.push({
            languageCode: this.editingLang,
            name: "",
            description: this.editableDesc,
          });
        }
      }
      this.cancelEdit();
    },
    cancelEdit() {
      this.editingItemId = null;
      this.editingLang = null;
      this.editableDesc = "";
    },
    async getPreviousPrescription() {
      if(this.isNewPrescription) {
        this.isGetPreviousPrescriptionFinished = true;
        this.mergeSelectedItems();
        return;
      }

      var self = this;
      const url =
        rest_service.baseURL + "/Medicinesuggestion/getpreviousprescription";
      const headers = {
        x_tenant_id: this.tenantId,
        role_unique_id: this.role_unique_id,
        loggedin_user_unique_id: this.loggedin_user_unique_id,
        route_entity_name: "/Medicinesuggestion",
        Authorization: this.authenticationToken,
      };

      var encounterId = "";
      var patientId = "";
      if (this.isGlobal) {
        encounterId = this.patientInfo.encounter_id;
        //const params = new URLSearchParams(window.location.search);
        patientId = this.patientInfo.unique_id;
      } else {
        encounterId = window.localStorage.getItem("encounterid");
        const params = new URLSearchParams(window.location.search);
        patientId = params.get("patient_id");
      }

      const prescriptions = {
        encounter_id: encounterId,
        patient_id: patientId,
      };

      this.isLoading = true;

      const response = await Axios.post(url, prescriptions, { headers })
        .then((response) => {
          const result = response.data.result;
          debugger
          if (result && Array.isArray(result) && result.length > 0) {
            this.IsPrintable = true;
            const firstLang = result[0].language_code;
            this.created_by_unique_id = result[0].modified_by
              ? result[0].modified_by
              : result[0].created_by;
            this.prescriptioncreatedtime = this.formatDateTime(
              result[0].created_date
            );
            if (firstLang) {
              this.selectedLanguage =firstLang;
            }
            result.forEach((savedItem) => {
              if (!savedItem.item_id) return;

              this.selectedItems.push(savedItem.item_id);

              this.listOfItems.forEach((group) => {
                if (!group.items) return;

                group.items.forEach((item) => {

                  if (String(item.itemId).trim() === String(savedItem.item_id).trim()) {

                    if (!item.languages) return;

                    item.languages.forEach((lang, index) => {

                      if (lang.languageCode === savedItem.language_code) {

                        const updatedLang = {
                          ...lang,
                          name: savedItem.name,
                          description: savedItem.description
                        };

                        this.$set(item.languages, index, updatedLang);

                        console.log("UPDATED:", item.itemId);
                      }

                    });

                  }

                });
              });
            });

          }

          self.isGetPreviousPrescriptionFinished = true;
          self.mergeSelectedItems();
        })
        .catch((error) => {
          console.error("Error saving prescriptions:", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    filterItems(items, keyword) {
      if (!keyword) return items;

      const lowerKeyword = keyword.toLowerCase();

      return items.filter((item) => {
        const langTelugu = item.languages.find(function (l) {
          return l.languageCode === "te";
        });
        const nameTelugu = langTelugu && langTelugu.name ? langTelugu.name : "";

        const langEnglish = item.languages.find(function (l) {
          return l.languageCode === "en";
        });
        const nameEnglish =
          langEnglish && langEnglish.name ? langEnglish.name : "";
        return (
          nameTelugu.toLowerCase().includes(lowerKeyword) ||
          nameEnglish.toLowerCase().includes(lowerKeyword)
        );
      });
    },
    oncloseclick() {
       this.selectedLanguage = 'te';
    },
    async getMedicineSuggestionList() {
      const url =
        rest_service.baseURL +
        "/Medicinesuggestion/GetMedicineNestedGroups/" +
        this.tenantId;

      const headers = { x_tenant_id: this.tenantId, role_unique_id: this.role_unique_id, loggedin_user_unique_id: this.loggedin_user_unique_id, route_entity_name: "/Medicinesuggestion", Authorization: this.authenticationToken, };

      this.isLoading = true;

      try {
        const response = await Axios.get(url, { headers });

        if (response.data && response.data.result) {
          this.listOfItems = response.data.result;
          this.preselectedIds = this.listOfItems.flatMap((group) =>
            group.items
              .filter((item) => item.isPreselected)
              .map((item) => item.itemId)
          );
        }

        this.isGetListFinished = true;
        this.mergeSelectedItems();
      } catch (error) {
        console.error("Error fetching item list:", error);
      } finally {
        this.isLoading = false;
      }
    },

    toggleSelection(itemId) {
      const index = this.selectedItems.indexOf(itemId);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems.push(itemId);
      }
    },
    isChecked(itemId) {
      return this.selectedItems.indexOf(itemId) > -1;
    },
    getItemName(item, lang) {
      const langEntry = item.languages.find((l) => l.languageCode === lang);
      return langEntry ? langEntry.name : "";
    },
    getLanguageDesc(item, lang) {
      const langEntry = item.languages.find((l) => l.languageCode === lang);
      return langEntry ? langEntry.description : "";
    },
    removeItem(itemId) {
      const index = this.selectedItems.indexOf(itemId);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      }
    },
    // selectLanguage(lang) {
    //   if (this.selectedLanguage === lang) {
    //     this.selectedLanguage = "te";
    //   } else {
    //     this.selectedLanguage = lang;
    //   }
    // },
    selectLanguage(lang) {
      this.selectedLanguage = lang;
    },

    SavePrescription(isPrint) {
      
      this.prescriptioncreatedtime = new Date().toISOString();
      if(isPrint) {this.printprescription()};
      const url =
        rest_service.baseURL + "/Medicinesuggestion/savedprescription";
      const headers = {
        x_tenant_id: this.tenantId,
        role_unique_id: this.role_unique_id,
        loggedin_user_unique_id: this.loggedin_user_unique_id,
        route_entity_name: "/Medicinesuggestion",
        Authorization: this.authenticationToken,
      };

      var encounterId = "";
      var patientId = "";
      if (this.isGlobal) {
        encounterId = this.patientInfo.encounter_id;
        //const params = new URLSearchParams(window.location.search);
        patientId = this.patientInfo.unique_id;
      } else {
        encounterId = window.localStorage.getItem("encounterid");
        const params = new URLSearchParams(window.location.search);
        patientId = params.get("patient_id");
      }

      var model = {};
      model.provider = {};

      const encounterParts = encounterId.split("_");
      if(encounterParts && encounterParts.length > 1) {
        model.appointmentId = encounterParts[1];
      }
      
      model.provider.unique_id = this.loggeedin_user.unique_id;
      model.provider.mobile = this.loggeedin_user.mobile;
      model.provider.signature_pic_file_name = this.loggeedin_user.signature_pic_file_name;
      model.provider.title = this.loggeedin_user.title;
      model.provider.email = this.loggeedin_user.email;
      model.provider.first_name = this.loggeedin_user.first_name;
      model.provider.last_name = this.loggeedin_user.last_name;
      model.provider.record_status = this.loggeedin_user.record_status;
      model.provider.tenant_id = this.loggeedin_user.tenant_id;
      model.provider.location_name = this.getlocationdata.location_name;
      model.provider.address = this.getlocationdata.address;
      this.loggeedin_user.category_list.forEach(element => {
          if (element.unique_id == this.loggeedin_user.default_category_id) {
              model.provider.category = element.category;
          }
      });

      model.shareWithPharmacy = true;

      model.prescriptions = this.selectedItemsData.map((item) => ({
          encounter_id: encounterId,
          patient_id: patientId,
          item_id: item.itemId,
          iten_order: item.itemOrder.toString() || "0",
          optional_selected_language_code: this.selectedLanguage,

          listLanguageDesc: item.languages.map((lang) => ({
              encounter_id: encounterId,
              item_id: item.itemId,
              language_code: lang.languageCode,
              name: lang.name,
              description: lang.description,
          })) || [],

          created_date: this.IsPrintable ? "" : new Date().toISOString(),
          modified_date: this.IsPrintable ? new Date().toISOString() : "",
          created_by: this.IsPrintable ? "" : this.loggedin_user_unique_id,
          modified_by: this.IsPrintable ? this.loggedin_user_unique_id : "",
      }));

      this.isLoading = true;

      Axios.post(url, model, { headers })
        .then((response) => {
          this.IsPrintable = true;
          if (!isPrint) {
            this.isdisplaymsg = true,
              this.iserrormsg = false,
              this.sucessmsgtext = "Prescription saved successfully."
          }
          setTimeout(() => {
            this.closeMessage();
            const appointment_id = encounterId.split("_")[1];
            this.$emit("prescription-saved", appointment_id);
            if (!isPrint) {
              $("#vsPrescriptionModal").modal("hide");
              $("#prescriptionPreview").modal("hide");
            }
            this.updatePatientStatus();
          }, 1500);
        })
        .catch((error) => {
          console.error("Error saving prescriptions:", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    updatePatientStatus() {
      
      const url = rest_service.baseURL + "/reception/update-appointment-status";
      const headers = {
        x_tenant_id: this.tenantId,
        role_unique_id: this.role_unique_id,
        loggedin_user_unique_id: this.loggedin_user_unique_id,
        route_entity_name: "/Reception",
        Authorization: this.authenticationToken,
      };

      // Get encounterId
      let encounterId = "";
      if (this.isGlobal) {
        encounterId = this.patientInfo.encounter_id;
      } else {
        encounterId = window.localStorage.getItem("encounterid");
      }

      const appointment_id = encounterId.split("_")[1];

      const patientstatusdb = JSON.parse(window.localStorage.getItem("patientstatusdb") || "[]");

      const matchedStatus = patientstatusdb.find(
        (item) => item.Status && item.Status.toLowerCase() === "prescription suggested"
      );

      const prescriptions = {
        tenant_id: this.tenantId,
        unique_id: appointment_id,
        patientStatus: matchedStatus ? matchedStatus.Status : "",
        patientStatus_Id: matchedStatus ? matchedStatus.ID : "",
      };

      // Call API
      Axios.post(url, prescriptions, { headers })
        .then((response) => {
          console.log("Patient status updated successfully");
        })
        .catch((error) => {
          console.error("Error updating patient status:", error);
        });
    },

    printprescription() {
      this.GetDoctorName();
      const printSection = this.$refs.printSectionPrescription;
      if (!printSection) {
        console.error("Print section not found");
        return;
      }

                        const printWindow = window.open(
    "",
    "PrintWindow",
    `width=${screen.width},height=${screen.height},top=0,left=0`
);

      this.$nextTick(() => {
        // Grab the HTML content of the prescription component
        const printContents = printSection.innerHTML;
        // Grab all component styles (scoped included) and inject them
        const styleTags = Array.from(document.querySelectorAll("style"))
          .map((tag) => tag.outerHTML)
          .join("\n");

        printWindow.document.write(`
                    <html>
                    <head>
                        <title>Print Prescription</title>
                        <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet">
                        ${styleTags} 
                        <style>
                        @page { size: A4; margin: 0; }
                        html, body { margin: 0; padding: 0; width: 100%; }
                        .prescription-text { white-space: pre-line !important; }
                        </style>
                    </head>
                    <body onload="window.print(); setTimeout(() => window.close(), 200);">
                        ${printContents}
                    </body>
                    </html>
                `);

        printWindow.document.close();
      });
    },

    async onDragEnd(event) {
      // Prepare payload if needed
      this.selectedItemsData.forEach(
        (item, index) => (item.item_order = index + 1)
      );
    },
    formatDateTime(isoString) {
      if (!isoString) return "";
      const dateObj = new Date(isoString);

      const day = String(dateObj.getDate()).padStart(2, "0");
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const year = dateObj.getFullYear();

      let hours = dateObj.getHours();
      const minutes = String(dateObj.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      hours = String(hours).padStart(2, "0");

      return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    },
  },
  Updated() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },
  computed: {
    medicinesList() {
      return this.listOfItems
        .filter((g) => g.groupType === "Medicines")
        .flatMap((g) => this.filterItems(g.items, this.searchMedicines))
        .sort((a, b) =>
          a.itemNameInEnglishOrFallback.localeCompare(
            b.itemNameInEnglishOrFallback,
            undefined,
            { sensitivity: "base" }
          )
        );
    },

    lifestyleList() {
      return this.listOfItems
        .filter((g) => g.groupType === "Lifestyle suggestions")
        .flatMap((g) => this.filterItems(g.items, this.searchLifestyle))
        .sort((a, b) =>
          a.itemNameInEnglishOrFallback.localeCompare(
            b.itemNameInEnglishOrFallback,
            undefined,
            { sensitivity: "base" }
          )
        );
    },

    selectedItemDetails() {
      return this.listOfItems
        .flatMap((g, groupIndex) =>
          g.items.map((i) => ({
            ...i,
            groupType: g.groupType,
            groupOrder: g.groupOrder != null ? g.groupOrder : groupIndex,
          }))
        )
        .filter((i) => this.selectedItems.includes(i.itemId))
        .sort((a, b) => {
          if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
          return (a.itemOrder || 0) - (b.itemOrder || 0);
        });
    },
  },
  watch: {
    selectedItemDetails: {
      handler(newVal) {
        this.selectedItemsData = newVal;
      },
      immediate: true,
    },
  },
};
</script>


<style scoped>
#vsPrescriptionModal .modal-dialog.modal-xl {
  max-width: 95%;
}

.modal-dialog .modal-header {
  padding: 0;
  justify-content: center;
  height: auto;
  min-height: inherit;
}

.modal-header .close {
  outline: none !important;
  padding: 0;
  margin: 0;
  top: -15px;
  right: 8px;
  opacity: 1 !important;
  color: #000 !important;
}

.modal-title {
  text-align: center;
  padding-bottom: 0;
  position: relative;
  top: 0;
  font-weight: 600;
  margin: 0;
}

.modal-body {
  padding: 15px 25px;
  margin-bottom: 0;
}

.prescription-languages h4 {
  font-size: 16px !important;
  font-weight: 600;
  margin: 0 0 10px;
}

.prescription-languages .languages-block {
  background: #f7f3f2;
  overflow: hidden;
  border-radius: 5px;
  padding: 4px 15px;
  margin-bottom: 20px;
}

.prescription-languages .languages-block label.container.customcheck {
  margin-right: 20px;
}

.prescription-languages
  .languages-block
  label.container.customcheck:first-child {
  cursor: default;
}

.prescription-tab .nav-tabs {
  border-bottom: none;
}

.prescription-tab .content-sec {
  background: #f7f3f2;
  padding: 25px 15px 15px;
  border-radius: 0 5px 5px 5px;
}

.prescription-tab ul li .nav-link {
  background: #fff;
  color: #000;
  font-weight: 500;
  display: flex;
  align-items: center;
  grid-gap: 8px;
  border: 1px solid #f7f3f2;
  min-width: 205px;
  justify-content: center;
  font-size: 15px;
  cursor: pointer;
}

.prescription-tab ul li .nav-link.active,
.prescription-tab ul li.show .nav-link {
  background: #f7f3f2 !important;
  color: #0056e0 !important;
  border-color: #f7f3f2;
}

.search-suggestions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  grid-gap: 30px;
}

.search-suggestions label {
  margin: 0;
  font-weight: 600;
  width: auto;
}

.search-suggestions .container-comm {
  max-width: 65%;
  width: 100%;
}

/* .search-suggestions .container-comm input {
    border-radius: 4px !important;
} */

.checkbox-block {
  overflow: auto;
  margin: 30px 0 0;
  display: flex;
  flex-wrap: wrap;
  grid-gap: 10px;
  max-height: 435px;
  padding-bottom: 40px;
}

.checkbox-block > .customcheck {
  max-width: calc(16.66% - 10px);
  width: 100%;
  display: flex;
  align-items: center;
  line-height: 1.2;
}

.checkbox-block .customcheck {
  background: #fff;
  border: 1px solid #ede7e7;
  padding: 16px 10px 15px 10px;
  border-radius: 5px;
  margin: 0 !important;
}

.checkbox-block .customcheck.stock-available {
  border-left-width: 4px;
}

.checkbox-block .customcheck.stock-available.stage-01 {
  border-left-color: #0dc660;
}

.checkbox-block .customcheck.stock-available.stage-02 {
  border-left-color: #eece17;
}

.checkbox-block .customcheck.stock-available.stage-03 {
  border-left-color: #ee7677;
}

.checkbox-block .customcheck span:first-child {
  text-transform: uppercase;
  font-weight: 500;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-left: 25px;
  font-size: 13px;
  word-break: break-word;
}

.checkbox-block .customcheck .checkmark {
  left: 10px;
  top: 50%;
  transform: translate(0, -50%);
}

.checkbox-block .customcheck .stock-count {
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-style: normal;
  font-size: 12px;
}

.checkbox-block .customcheck.stage-01 .stock-count {
  color: #0dc660;
}

.checkbox-block .customcheck.stage-02 .stock-count {
  color: #eece17;
}

.checkbox-block .customcheck.stage-03 .stock-count {
  color: #ee7677;
}

.legend-list {
  margin: 20px 0 0 0;
}

.legend-list ul {
  display: flex;
  gap: 30px;
}

.legend-list ul li {
  font-size: 12px;
}

.legend-list ul li.stock-legend span {
  width: 17px;
  height: 17px;
  display: inline-block;
  vertical-align: top;
  margin-right: 5px;
  border-radius: 5px;
}

.legend-list ul li.stock-legend.legend-stage-01 span {
  background: #0dc660;
}

.legend-list ul li.stock-legend.legend-stage-02 span {
  background: #eece17;
}

.legend-list ul li.stock-legend.legend-stage-03 span {
  background: #ee7677;
}

.prescription-preview {
  margin: 40px 0 0;
}

.prescription-preview h4 {
  font-size: 16px !important;
  font-weight: 600;
  margin: 0 0 10px;
}

.prescription-preview table thead tr {
  background: #f7f3f2;
  border: none;
}

.prescription-preview table tr th,
.prescription-preview table tr td {
  border: 1px solid #ede4e5 !important;
  color: #000;
}

.prescription-preview table tr td .form-control {
  margin: 0 auto;
  border: 1px solid #ede4e5 !important;
  height: auto !important;
  padding: 10px;
  border-radius: 4px !important;
  max-width: 250px;
}

.prescription-preview table tr td .del-icon {
  color: #f63c3d;
  font-size: 20px;
  display: inline-block;
  margin: 0 auto;
}

.prescription-preview table tr td ~ td,
.prescription-preview table tr th ~ th {
  text-align: center;
}

.prescription-preview table tbody tr:nth-child(2n) {
  background: #f7f3f2;
}

.prescription-preview table tr td .p-name {
  text-transform: uppercase;
  font-weight: 500;
}

.prescription-modal .primary-btn {
  float: none;
  /* border-radius: 5px; */
}

#prescriptionPreview .modal-dialog {
  max-width: 850px;
}

.preview-drag-block {
  background: #f7f3f2;
  border-radius: 5px;
  padding: 25px;
  overflow: auto;
  max-height: 500px;
}

.drag-block {
  background: #eef7ff;
  border: 1px solid #0f6ccc;
  border-radius: 5px;
  padding: 15px;
  width: 100%;
}

.drag-block .top {
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
}

.drag-block .top span {
  color: #0f6ccc;
  font-weight: 600;
  font-size: 14px;
  display: inline-block;
  margin-left: 5px;
}

.drag-block .top > div a {
  font-size: 18px;
  margin: 0 5px;
}

.drag-block .top > div a.edit-icon {
  color: #666;
}

.drag-block .top > div a.del-icon {
  color: #f63c3d;
}

.drag-block .main-content {
  margin: 0 0 0 5px;
  width: 100%;
}

.main-content div .main-content-sub {
  border-bottom: 1px solid #aeb7bf;
  margin-bottom: 10px;
  padding-bottom: 10px;
  position: relative;
  min-height: 20px;
}

.drag-block h4 {
  font-weight: 600;
  font-size: 16px !important;
  text-transform: uppercase;
  margin: 0 0 5px 0;
  word-break: break-word;
}

.drag-block p {
  margin: 0;
  font-weight: 400;
  font-size: 13px;
  width: calc(100% - 26px);
}

/* .drag-block .edit-section {
    min-width: 50px;
} */

.main-content div .main-content-sub {
  border-bottom: 1px solid #aeb7bf;
  margin-bottom: 10px;
  padding-bottom: 10px;
  position: relative;
}
.main-content div:last-child .main-content-sub {
  border-bottom: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}

.drag-block .edit-section.bottom {
  text-align: right;
  position: absolute;
  right: 0;
  top: 0;
}

.main-content div .edit-hold {
  border-bottom: 1px solid #aeb7bf;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.main-content div:last-child .edit-hold {
  border: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}

.main-content div .edit-hold .form-control {
  margin: 0 0 10px 0;
}

.main-content div .edit-hold .edit-buttons {
  text-align: right;
}

.main-content div .edit-hold .ripple {
  min-width: 0;
  padding: 4px 10px;
  margin-left: 10px;
  float: none;
  font-size: 12px;
  font-weight: normal;
}

.drag-main-block {
  display: flex;
  align-items: center;
  grid-gap: 10px;
  margin-bottom: 10px;
}

.drag-main-block .drag-icon {
  color: #0f6ccc;
  min-width: 30px;
  display: flex;
}

.drag-main-block .drag-icon i {
  margin: 0 1px;
  font-size: 25px;
}

.drag-block.morning {
  border: 1px solid #fcdb93;
  background: #fff6e4;
}

.drag-block.morning .top span {
  color: #f7b824;
}

.drag-block.evening {
  border: 1px solid #6ff7bc;
  background: #e4fff8;
}

.drag-block.evening .top span {
  color: #2fb57e;
}

.preview-drag-modal > div.text-right {
  display: flex;
  grid-gap: 10px;
  justify-content: flex-end;
  margin-top: 15px;
}

.drag-legend {
  display: inline-block;
  width: 100%;
  margin: 10px 0 0 0;
  color: #007bff;
  /* text-align: right; */
  padding-right: 10px;
}
.drag-legend p {
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
}
.drag-legend i {
  font-size: 25px;
  margin: 0 1px;
}

/* .secondary-btn,
.primary-btn {
    border-radius: 5px;
} */

#prescriptionPreview {
  z-index: 1051 !important;
}

#prescriptionPreview:before {
  content: "";
  position: fixed;
  background: #000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.5;
}

.drag-icon {
  cursor: move;
  padding: 30px 5px;
  color: #999;
  font-size: 18px;
  align-self: center;
}

/* Visual feedback while dragging */
.drag-over {
  background: #e9f5ff;
  border-color: #007bff;
}
.prescription-text {
  white-space: pre-line; 
}

@media (max-width: 991px) {
  .checkbox-block > .customcheck {
    max-width: calc(25% - 10px);
  }
}

@media (max-width: 767px) {
  .checkbox-block > .customcheck {
    max-width: calc(33.33% - 10px);
  }

  .search-suggestions {
    display: block;
  }

  .search-suggestions .container-comm {
    max-width: 100%;
    margin-top: 10px;
  }
}

@media (max-width: 575px) {
  .checkbox-block > .customcheck {
    max-width: calc(50% - 10px);
  }

  .prescription-tab ul li .nav-link {
    min-width: inherit;
    font-size: 13px;
    padding: 10px 12px;
  }
}

@media (max-width: 479px) {
  .checkbox-block > .customcheck {
    max-width: 100%;
  }
}
</style>
